import lockScroll from '../__utils/lockScroll';
class Modal {
    constructor() {
        this.trigger = document.querySelectorAll('[data-modal-trigger]');
        this.close = document.querySelectorAll('[data-modal-close]');
    }

    init() {
        if (this.trigger) {
            [...this.trigger].forEach(element => {
                element.addEventListener('click', (e) => this.openModal(e))
            });
        }
        if (this.close) {
            [...this.close].forEach(element => {
                element.addEventListener('click', (e) => this.closeModal(e))
            });
        }
    }

    openModal(e) {
        const wrapper = e.target.parentElement;
        wrapper.querySelector('[data-modal-wrapper]').classList.add('modal-active');
        lockScroll.lock();
    }
    
    closeModal(e) {
        e.target.closest('[data-modal-wrapper]').classList.remove('modal-active');
        lockScroll.unlock()
    }
}

export default new Modal();